/**
 * 解析参数
 * @param query
 * @returns
 */
const parseQuery = (query = '') =>
  query
    .replace('?', '')
    .split('&')
    .map((qs: string) => {
      const [k, v] = qs.split('=')
      return { [k]: decodeURIComponent(v) }
    })
    .reduce((result, curr) => ({ ...result, ...curr }), {})

export default parseQuery
